module.exports = __webpack_public_path__ + "img/rms-app-calendar.350f322c.png";